<div [ngClass]="widgetIsShown ? 'login-modal-wrapper-shifted' : 'login-modal-wrapper'" fxLayout="column" fxLayoutAlign="start">
  <div fxLayoutAlign="start" style="padding-top: 20px; padding-left: 20px;">
    <button
      *ngIf="user?.globalSettings?.trackingOptions?.isActive"
      [routerLink]="['/track-order']"
      color="primary"
      mat-raised-button
      matDialogClose
      type="button"
      style="margin-bottom: 16px;"
    >
      Guest Tracking
    </button>
  </div>
  <div fxLayoutAlign="end" style="position: absolute; top: 0px; right: 20px; z-index: 10;">
    <button
      (click)="guestLogin()"
      *ngIf="user?.globalSettings?.allowGuest"
      mat-button
      type="button"
    >
      <span class="no-account">{{'loginView.noAccountLabel' | translate}}</span>
      <span class="white-text">{{'loginView.guestOrderLabel' | translate}}</span>
    </button>
  </div>
  <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
    <div class="logo-wrapper" fxLayout="column" fxLayoutAlign="start center">
      <app-logo-svg *ngIf="!companyLogo" [white]="selectedTab === 'worker'"></app-logo-svg>
      <img
        *ngIf="companyLogo"
        alt="{{'loginView.title' | translate}} {{'loginView.subtitle' | translate}}"
        class="company-logo"
        src="{{companyLogo}}"
      />
    </div>
    <div class="login-wrapper">
      <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="5px">
        <div></div>
        <button
          (click)="selectTab('inet')"
          [ngClass]="{'translucent':selectedTab !== 'inet'}"
          class="remove-radius-bottom"
          mat-raised-button
          type="button"
        >
          <span>{{'loginView.userLoginTab' | translate}}</span>
        </button>
        <button
          (click)="selectTab('worker')"
          [ngClass]="{'translucent':selectedTab !== 'worker'}"
          class="remove-radius-bottom"
          mat-raised-button
          type="button"
        >
          <span>{{'loginView.driverLoginTab' | translate}}</span>
        </button>
      </div>
      <mat-card>
        <mat-card-content>
          <form (ngSubmit)="login(form)" [formGroup]="form" fxLayout="column" fxLayoutAlign="start">
            <mat-form-field fxFlex>
              <mat-label *ngIf="selectedTab === 'inet'">{{'loginView.userNameLabel' | translate}}</mat-label>
              <mat-label *ngIf="selectedTab === 'worker'">{{'loginView.driverIdLabel' | translate}}</mat-label>
              <input
                #username
                [type]="selectedTab === 'worker' ? 'number' : 'text'"
                autocapitalize="off"
                (keydown.enter)="usernameEnter($event)"
                formControlName="username"
                matInput
                required
                spellcheck="false"
                (blur)="removeExtraSpaces()"
              />
              <button
                *ngIf="selectedTab === 'inet' && hasSso && displayPasswordBox"
                (click)="resetForm()"
                matTooltip="Reset Username"
                color="warn"
                mat-icon-button
                matSuffix
                matTooltipPosition="left"
                type="button"
              >
                <mat-icon>cancel</mat-icon>
              </button>
              <mat-error>{{'loginView.userNameLabel' | translate}} is required</mat-error>
            </mat-form-field>
						<mat-form-field fxFlex *ngIf="displayPasswordBox">
							<mat-label>{{'loginView.passwordLabel' | translate}}</mat-label>
							<input #password [type]="showPassword ? 'text' : 'password'" formControlName="password" matInput
								   required/>
							<button (click)="toggleShowPassword()"
									[matTooltip]="showPassword ? 'Hide Password' : 'Show Password'"
									color="primary"
									mat-icon-button matSuffix matTooltipPosition="left" type="button">
								<mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
							</button>
							<mat-error>{{'loginView.passwordLabel' | translate}} is required</mat-error>
						</mat-form-field>
						<mat-form-field appearance="none" fxFlex *ngIf="displayPasswordBox">
							<div>
								<input matInput class="display-none">
								<mat-checkbox color="primary" formControlName="rememberMe">
									{{'loginView.rememberMeText' | translate}}
								</mat-checkbox>
							</div>
						</mat-form-field>
						<div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="15px">
              <button color="primary" mat-raised-button type="submit" *ngIf="displayPasswordBox">
                  Login
              </button>
              <button color="primary" mat-raised-button type="button" (click)="continue()" *ngIf="!displayPasswordBox">
                  {{'loginView.continueButton' | translate}}
              </button>
            </div>
					</form>
          <div class="footer-info" fxLayout="column" style="margin-top: 24px;">
            <div class="account-links" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="15px">
                <a *ngIf="showAccountOrLoginCreationLink" [routerLink]="['/register']" matDialogClose>{{'loginView.createAccountText' | translate}}</a>
                <span *ngIf="showAccountOrLoginCreationLink" class="version">|</span>
                <a (click)="forgotPassword()" href="javascript:void(0)">{{'loginView.forgotPasswordText' | translate}}</a>
            </div>
            <div class="app-info" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="15px">
                <span class="version">Version: {{version}}</span>
                <div>
                    <a class="copyright" href="https://cxtsoftware.com/" target="_blank">&copy; CXT Software {{year}}</a>
                    <span class="version-timestamp">Build timestamp: {{buildTimestamp}}</span>
                </div>
            </div>
        </div>

        </mat-card-content>
			</mat-card>
    </div>
</div>
